/* eslint-disable */

import { useNavigate } from 'react-router-dom'
import kycBank from '../../assets/Popups/kyc-bank.svg'
import kycNominee from '../../assets/Popups/kyc-nominee.svg'
import kycPan from '../../assets/Popups/kyc-pan.svg'
import FullPagePopupLayout from './FullPagePopupLayout'

const KYC_DOCUMENTS = [
  {
    icon: kycPan,
    alt: 'pan-card-image',
    title: 'PAN Card',
    description: 'PAN number and date of birth (as on PAN)',
  },
  {
    icon: kycBank,
    alt: 'account-balance-image',
    title: 'Bank Details',
    description: 'Bank account number and IFSC code',
  },
  {
    icon: kycNominee,
    alt: 'nominee-details-image',
    title: 'Nominee Details',
    description: 'Nominee PAN, date of birth, email, and mobile number',
  },
]

const KycPopup = ({ open, onClose }) => {
  const navigate = useNavigate()

  const handleCompleteKyc = () => {
    onClose()
    navigate('/dashboard/start-kyc')
  }

  return (
    <FullPagePopupLayout
      isOpen={open}
      onClose={onClose}
      severity='info'
      title='Complete your KYC to proceed'
      message='Keep the following details handy before you proceed.'
      bodyClassName='fabits-kyc-doc-popup-body'
      actionsClassName='fabits-global-popup-actions-single'
      actions={
        <button
          type='button'
          className='fabits-global-popup-button fabits-global-popup-button-primary'
          onClick={handleCompleteKyc}
        >
          Continue
        </button>
      }
    >
      <div className='fabits-kyc-document-list'>
        {KYC_DOCUMENTS.map((doc) => (
          <div key={doc.title} className='fabits-kyc-document-row'>
            <img src={doc.icon} alt={doc.alt} className='fabits-kyc-document-icon' />
            <div>
              <p className='fabits-kyc-document-title'>{doc.title}</p>
              <p className='fabits-kyc-document-description'>{doc.description}</p>
            </div>
          </div>
        ))}
      </div>

      <p className='fabits-kyc-help-text'>
        Need help? Reach out at <span>+91-8050034800</span>.
      </p>
    </FullPagePopupLayout>
  )
}

export default KycPopup
